"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vuex_1 = __importDefault(require("vuex"));
const Module_1 = __importDefault(require("./Module"));
const Interface_1 = __importStar(require("./Interface"));
const PagePoolModule_1 = __importDefault(require("./PagePoolModule"));
let Vue;
let modules = {};
let interfaces = {};
let plugins;
let templateFunctions = {};
let customStuff = {
    modules: {},
    interfaces: [],
};
function install(_Vue) {
    if (Vue && _Vue === Vue) {
        if (process.env.NODE_ENV !== 'production') {
            console.error('[RestX] already installed. Vue.use(RestX) should be called only once.');
        }
        return;
    }
    Vue = _Vue;
    Vue.use(vuex_1.default);
}
/**
 * createTemplateFunctions({
 *      setCookie(token): asdasd
 *      retrieveCoockie(): return token
 * })
 */
function registerTemplateFunctions(config) {
    templateFunctions = config;
}
/**
 * createPlugins([
 *      {
 *          storage: window.localStorage,
 *          modules: ['user']
 *      }
 * ])
 */
function registerPlugins(arrayOfPlugins) {
    plugins = arrayOfPlugins;
}
function createCustomModule(namespace, description) {
    customStuff.modules[namespace] = Object.assign({ namespaced: true }, description);
    customStuff.interfaces.push({ namespace, description });
}
function createStore(branches = {}, logger = { log() { }, error() { } }) {
    logger.log('Creating store');
    let branchEntries = Object.entries(branches);
    modules = Object.assign(Object.assign({}, modules), generateModules(branchEntries, logger));
    // console.log(plugins);
    let store = new vuex_1.default.Store({
        modules: Object.assign(Object.assign(Object.assign({}, ((customStuff || {}).modules || {})), modules), { pagePool: PagePoolModule_1.default || {} }),
        plugins: plugins || [],
    });
    interfaces = Object.assign(Object.assign({}, interfaces), generateInterfaces(branchEntries, store, logger));
    customStuff.interfaces.forEach(({ namespace, description }) => {
        interfaces[namespace] = Interface_1.createCustomInterface(store, namespace, description);
    });
    if (Vue)
        Vue.prototype.$interfaces = interfaces;
    return store;
}
const generateModules = (branchEntries, logger) => branchEntries
    .map(([k, v]) => [k, Module_1.default(v, logger, templateFunctions)])
    .reduce(objectFromEntries, {});
const generateInterfaces = (branchEntries, store, logger) => branchEntries
    .map(([k, v]) => [k, new Interface_1.default(store, k, v, null, null, logger)])
    .reduce(objectFromEntries, {});
const objectFromEntries = (acc, [k, v]) => (Object.assign(Object.assign({}, acc), { [k]: v }));
const getInterfaces = () => interfaces;
exports.default = {
    install,
    createStore,
    modules,
    getInterfaces,
    registerTemplateFunctions,
    registerPlugins,
    createCustomModule,
};
